import React from 'react'

// The atmospheric background lives in index.css, without a canvas or resize listeners.
export default function BackgroundAnimation(): JSX.Element {
  return <></>
}
